export default __webpack_public_path__ + "static/media/socialmedia.4f26635e.svg";